export default "__VITE_PUBLIC_ASSET__66f0d142__"